export const featuredMovies = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    category: '科幻',
    year: '2026',
    rating: '9.2',
    quality: '4K',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20scifi%20movie%20poster%20with%20dramatic%20deep%20red%20and%20dark%20space%20background%2C%20golden%20lighting%20accents%2C%20professional%20film%20poster%20aesthetic%2C%20clean%20composition%20with%20futuristic%20elements%2C%20no%20visible%20faces%2C%20warm%20theater%20atmosphere&width=600&height=900&seq=movie-card-01&orientation=portrait',
    description: '太阳系即将毁灭，人类再次踏上星际流浪之旅，寻找新的家园。',
  },
  {
    id: 'movie-2',
    title: '封神第二部',
    category: '奇幻',
    year: '2026',
    rating: '8.9',
    quality: '4K',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20fantasy%20movie%20poster%20with%20warm%20golden%20and%20crimson%20tones%2C%20ancient%20Chinese%20mythological%20aesthetic%2C%20dramatic%20lighting%20with%20fire%20and%20smoke%20elements%2C%20epic%20composition%2C%20no%20visible%20faces%2C%20dark%20rich%20background&width=600&height=900&seq=movie-card-02&orientation=portrait',
    description: '商周大战一触即发，姜子牙率众神将迎战纣王大军。',
  },
  {
    id: 'movie-3',
    title: '长安十二时辰',
    category: '古装',
    year: '2025',
    rating: '9.0',
    quality: '1080P',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20historical%20drama%20poster%20with%20warm%20amber%20and%20deep%20red%20tones%2C%20ancient%20Chinese%20Tang%20dynasty%20aesthetic%2C%20lantern%20lights%20and%20palace%20silhouettes%2C%20dramatic%20composition%2C%20no%20visible%20faces%2C%20elegant%20traditional%20style&width=600&height=900&seq=movie-card-03&orientation=portrait',
    description: '大唐盛世下暗流涌动，一场惊天阴谋在长安城悄然展开。',
  },
  {
    id: 'movie-4',
    title: '深海寻踪',
    category: '悬疑',
    year: '2026',
    rating: '8.7',
    quality: '4K',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20mystery%20thriller%20poster%20with%20deep%20ocean%20blueblack%20tones%20and%20warm%20light%20accents%2C%20underwater%20atmosphere%2C%20dramatic%20shadows%2C%20mysterious%20composition%2C%20no%20visible%20faces%2C%20dark%20rich%20aesthetic&width=600&height=900&seq=movie-card-04&orientation=portrait',
    description: '深海之下隐藏着不为人知的秘密，一支探险队踏上惊险旅程。',
  },
  {
    id: 'movie-5',
    title: '狂飙人生',
    category: '动作',
    year: '2025',
    rating: '8.8',
    quality: '1080P',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20action%20movie%20poster%20with%20warm%20deep%20red%20and%20dark%20tones%2C%20dramatic%20spotlight%20effect%2C%20urban%20night%20atmosphere%2C%20intense%20composition%2C%20no%20visible%20faces%2C%20professional%20film%20photography%20style&width=600&height=900&seq=movie-card-05&orientation=portrait',
    description: '退役特种兵为守护家人，重新踏上充满危险的征程。',
  },
  {
    id: 'movie-6',
    title: '星辰大海',
    category: '爱情',
    year: '2026',
    rating: '8.5',
    quality: '4K',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20romance%20movie%20poster%20with%20warm%20golden%20sunset%20and%20soft%20rose%20tones%2C%20dreamy%20atmosphere%2C%20gentle%20lighting%2C%20romantic%20composition%2C%20no%20visible%20faces%2C%20elegant%20aesthetic&width=600&height=900&seq=movie-card-06&orientation=portrait',
    description: '两个追梦人在异国他乡相遇，谱写一段跨越星辰的浪漫故事。',
  },
  {
    id: 'movie-7',
    title: '猎冰',
    category: '犯罪',
    year: '2025',
    rating: '9.1',
    quality: '4K',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20crime%20thriller%20poster%20with%20dark%20moody%20tones%20and%20warm%20red%20accents%2C%20noir%20atmosphere%2C%20dramatic%20shadows%20and%20contrast%2C%20intense%20composition%2C%20no%20visible%20faces%2C%20gritty%20film%20aesthetic&width=600&height=900&seq=movie-card-07&orientation=portrait',
    description: '缉毒警察深入虎穴，与毒贩展开一场惊心动魄的正邪较量。',
  },
  {
    id: 'movie-8',
    title: '少年歌行',
    category: '动画',
    year: '2026',
    rating: '9.3',
    quality: '4K',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20animated%20film%20poster%20with%20warm%20vibrant%20red%20and%20golden%20tones%2C%20Chinese%20martial%20arts%20aesthetic%2C%20ink%20brush%20style%20background%2C%20dynamic%20composition%2C%20no%20visible%20faces%2C%20artistic%20animation%20style&width=600&height=900&seq=movie-card-08&orientation=portrait',
    description: '少年剑客踏遍江湖路，寻找传说中的绝世武功秘籍。',
  },
];

export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-movie-line' },
  { slug: 'movie', name: '电影', icon: 'ri-film-line' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'variety', name: '综艺', icon: 'ri-emotion-laugh-line' },
  { slug: 'anime', name: '动漫', icon: 'ri-rocket-line' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-earth-line' },
  { slug: 'scifi', name: '科幻', icon: 'ri-planet-line' },
  { slug: 'action', name: '动作', icon: 'ri-fire-line' },
  { slug: 'comedy', name: '喜剧', icon: 'ri-emotion-happy-line' },
  { slug: 'romance', name: '爱情', icon: 'ri-heart-line' },
  { slug: 'horror', name: '悬疑', icon: 'ri-ghost-line' },
  { slug: 'costume', name: '古装', icon: 'ri-vip-crown-line' },
];

export const latestArticles = [
  {
    id: 'article-1',
    title: '《流浪地球3》首周票房突破30亿，国产科幻再创辉煌',
    excerpt: '备受瞩目的国产科幻大片《流浪地球3》上映首周即斩获30亿票房，刷新多项纪录，观众口碑持续走高，被誉为国产科幻电影新里程碑。',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20box%20office%20reporting%20scene%20with%20warm%20golden%20theater%20lighting%2C%20professional%20film%20industry%20environment%2C%20clean%20editorial%20photography%2C%20soft%20dramatic%20shadows%2C%20no%20visible%20text%2C%20elegant%20cinema%20atmosphere&width=800&height=500&seq=article-img-01&orientation=landscape',
    category: '票房盘点',
    date: '2026-08-01',
    readCount: '128,000',
    author: '影视观察员',
    content: '',
  },
  {
    id: 'article-2',
    title: '2026暑期档神仙打架：十大必看影视剧推荐',
    excerpt: '暑期档竞争激烈，多部大制作影视剧轮番上映。从科幻巨制到温情家庭剧，我们为你精心挑选了今夏最值得观看的十部作品，总有一部适合你。',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20summer%20movie%20season%20scene%20with%20warm%20sunset%20golden%20lighting%2C%20film%20recommendation%20editorial%20style%2C%20clean%20modern%20composition%2C%20soft%20shadows%2C%20no%20text%2C%20professional%20photography&width=800&height=500&seq=article-img-02&orientation=landscape',
    category: '观影指南',
    date: '2026-07-28',
    readCount: '96,500',
    author: '片多多编辑部',
    content: '',
  },
  {
    id: 'article-3',
    title: '国产动漫崛起：《少年歌行》口碑爆棚背后的故事',
    excerpt: '《少年歌行》凭借精美画面和扎实剧情，成为今年最受好评的国产动漫作品。导演独家分享创作幕后，揭秘这部诚意之作的诞生历程。',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20animation%20studio%20scene%20with%20warm%20artistic%20lighting%2C%20Chinese%20animation%20production%20environment%2C%20creative%20editorial%20photography%2C%20soft%20dramatic%20tones%2C%20no%20text%2C%20professional%20aesthetic&width=800&height=500&seq=article-img-03&orientation=landscape',
    category: '深度解析',
    date: '2026-07-25',
    readCount: '85,200',
    author: '动漫观察家',
    content: '',
  },
  {
    id: 'article-4',
    title: '从《封神》系列看中国神话IP影视化的未来',
    excerpt: '《封神》系列电影的成功为中国神话IP影视化开辟了新路径。本文深度分析中国神话宇宙的构建逻辑与未来发展方向，探讨国产奇幻电影的可能性。',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20film%20industry%20analysis%20scene%20with%20warm%20golden%20lighting%2C%20professional%20film%20criticism%20environment%2C%20clean%20editorial%20composition%2C%20dramatic%20shadows%2C%20no%20text%2C%20elegant%20aesthetic&width=800&height=500&seq=article-img-04&orientation=landscape',
    category: '行业观察',
    date: '2026-07-20',
    readCount: '72,800',
    author: '影视评论人',
    content: '',
  },
];

export const faqData = [
  {
    question: '片多多影视真的完全免费吗？',
    answer: '是的，片多多影视致力于为广大影迷提供完全免费的观影体验。所有电影、电视剧、综艺、动漫等资源均免费在线观看，无需任何付费会员或订阅。我们通过广告合作维持运营，确保用户享受纯净的免费观影服务。',
  },
  {
    question: '片多多影视支持哪些设备观看？',
    answer: '片多多影视全面支持PC端、平板电脑和手机端观看。无论您使用Windows、Mac、iOS还是安卓设备，都可以畅享高清流畅的观影体验。只需打开浏览器访问片多多影视即可，无需下载任何APP。',
  },
  {
    question: '片多多影视的画质如何？是否支持高清甚至超清播放？',
    answer: '片多多影视提供多种画质选择，包括720P高清、1080P全高清以及4K超清画质。您可以根据自己的网络状况和设备性能自由切换最佳画质。我们的片源均为正版授权，确保画面清晰细腻，色彩饱满真实。',
  },
  {
    question: '观看过程中卡顿怎么办？',
    answer: '片多多影视采用先进的CDN加速技术和智能码率调节，绝大多数情况下都能保证流畅播放。如果遇到卡顿，建议您：1）检查网络连接；2）尝试切换到较低画质；3）关闭其他占用带宽的应用；4）清理浏览器缓存后重试。我们的技术团队24小时保障服务器稳定运行。',
  },
  {
    question: '片多多影视的资源更新速度快吗？',
    answer: '非常快！片多多影视拥有专业的内容更新团队，热门电影电视剧上线后24小时内即可观看。院线电影下映后最快15天内上线，综艺节目播出后次日更新，动漫番剧同步日本播出。关注我们的更新公告，不错过任何精彩内容。',
  },
  {
    question: '是否需要注册账号才能观看？',
    answer: '不需要！片多多影视完全免注册观看，打开即看，方便快捷。如果您希望收藏喜欢的影片、记录观看历史或发表评论，也可以选择免费注册账号。但我们始终坚持"不注册也能看"的原则，让每位用户都能无障碍畅享影视内容。',
  },
];

export const stats = [
  { label: '影视资源', value: '50,000+', icon: 'ri-movie-line' },
  { label: '日均播放', value: '800万+', icon: 'ri-play-circle-line' },
  { label: '活跃用户', value: '2,000万+', icon: 'ri-user-heart-line' },
  { label: '高清片源', value: '98%', icon: 'ri-4k-line' },
];

export const heroSlides = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20theater%20atmosphere%20with%20warm%20deep%20red%20velvet%20curtains%20and%20golden%20stage%20lighting%2C%20dramatic%20spotlight%20effects%2C%20luxurious%20and%20elegant%20cinema%20interior%20with%20soft%20ambient%20glow%2C%20artistic%20composition%2C%20high%20contrast%20between%20deep%20reds%20and%20warm%20golden%20highlights%2C%20no%20text%2C%20clean%20colorgrading%2C%20cinematic%20photography%20style&width=1920&height=1080&seq=hero-slide-01&orientation=landscape',
    title: '片多多影视',
    subtitle: '海量高清免费影视，不卡顿在线看',
    description: '50,000+影视资源免费看，4K超清画质，畅享极致观影体验',
    cta: '立即观看',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20summer%20blockbuster%20atmosphere%20with%20warm%20golden%20sunset%20lighting%20and%20deep%20amber%20tones%2C%20dramatic%20movie%20marquee%20lights%2C%20elegant%20cinema%20exterior%20at%20dusk%2C%20luxurious%20theater%20aesthetic%2C%20no%20text%2C%20rich%20warm%20colors%2C%20professional%20cinematography&width=1920&height=1080&seq=hero-slide-02&orientation=landscape',
    title: '暑期档热播大片',
    subtitle: '全网同步更新，极速上线不等待',
    description: '院线热门影片、热门剧集第一时间上线，追剧快人一步',
    cta: '探索热门',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20luxury%20home%20theater%20with%20warm%20deep%20reds%20and%20golden%20accents%2C%20large%20projection%20screen%20with%20dramatic%20lighting%2C%20cozy%20premium%20viewing%20environment%2C%20soft%20ambient%20glow%2C%20no%20visible%20faces%2C%20high%20contrast%20cinematic%20style%2C%20rich%20atmosphere&width=1920&height=1080&seq=hero-slide-03&orientation=landscape',
    title: '4K超清画质',
    subtitle: '视觉盛宴，身临其境的观影感受',
    description: '先进的视频编码技术，每一帧都清晰动人，给你影院级体验',
    cta: '体验超清',
  },
];